import Users from "../../components/admin/users";
import { UserGroupIcon, LinkIcon, ComputerDesktopIcon } from '@heroicons/react/20/solid'
import { useState } from "react";
import PurchaseLinks from "../../components/admin/purchase-links";
import Updates from "../../components/admin/updates";
import Licences from "../../components/admin/licences";

const sideBarNavigation = {
    navItems: [
        {
            text: "Manage Users",
            icon: <UserGroupIcon className="w-7 h-7"/>,
            component: <Users/>
        },
        {
            text: "Purchase Links",
            icon: <LinkIcon className="w-7 h-7"/>,
            component: <PurchaseLinks/>
        },
        {
            text: "Updates",
            icon: <ComputerDesktopIcon className="w-7 h-7"/>,
            component: <Updates/>
        },
        {
            text: "Licences",
            icon: <ComputerDesktopIcon className="w-7 h-7"/>,
            component: <Licences/>
        }
    ]
}


const AdminDashboard = () => {
    const [activeNav, setActiveName] = useState(sideBarNavigation.navItems[0]);

    const handleNavClick = (nav) => {
        setActiveName(nav);
    }

    return (
        <div className="h-full md:h-screen flex bg-white dark:bg-[#202023] overflow-x-hidden">
            {/* Navigation Menu */}
            <div className=" overflow-y-auto bg-[#18181B] p-6">
                <div className="shrink-0">
                    <div className="">
                        <img alt="logo" src="https://yoghurtbot.io/assets/images/temp/logo.png"/>
                    </div>
                </div>
                <div className="pt-10 pb-3 border-b text-center text-xl">
                    <span className="dark:text-white !text-opacity-90">Admin Dashboard</span>
                </div>
                <div className="flex flex-col w-60">
                    {/* Navigation Menu */}
                    <div className="flex flex-col flex-1">
                        <nav className="flex-1 py-3">
                            {
                                sideBarNavigation.navItems.map((item, index) => (
                                    <button
                                      onClick={() => handleNavClick(item)}
                                      className="flex justify-start items-center space-x-6 hover:text-white focus:bg-gray-700 focus:text-white hover:bg-gray-700 text-gray-400 rounded px-3 py-2  w-full md:w-52">
                                        {item.icon}
                                        <p className="text-base leading-4">{item.text}</p>
                                    </button>
                                ))
                            }
                        </nav>
                    </div>
                </div>
            </div>

            {/*Main Contents*/}
            <div className="flex flex-col w-0 flex-1 md:overflow-y-auto">
                <main className="flex-1 relative focus:outline-none">
                    {activeNav.component}
                </main>
            </div>
        </div>
    )

}


export default AdminDashboard;